import styled from "styled-components";
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { css } from 'styled-components';
import { motion, scale } from "framer-motion";
import { useState, useRef, useEffect } from "react";

export default function Header() {
  const { t } = useTranslation();
  

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'es' ? 'en' : 'es');
  };

  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  const navRef = useRef<HTMLDivElement>(null);
  const sidebarVariants = {
  open: {
    clipPath: `circle(150% at right 35px top 42px)`,
    transition: {
      type: "spring",
      stiffness: 20,
      restDelta: 2,
    },
  },
  closed: {
    clipPath: `circle(0px at right 35px top 42px)`,
    transition: {
      delay: 0.1,
      type: "spring",
      stiffness: 400,
      damping: 40,
    },
  },
};
const listVariants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: { y: { stiffness: 1000, velocity: -100 } },
  },
  closed: {
    opacity: 0,
    y: 50,
    transition: { y: { stiffness: 1000 } },
  },
};

  return (
    <HeaderWrapper>
      <Title onClick={() => scroll.scrollToTop()}>RedDigitalCreations</Title>
         <motion.div
        ref={navRef}
        initial={false}
        animate={isOpen ? "open" : "closed"}
        variants={sidebarVariants}
        style={navMobileStyle}
        >
        <MenuUlMobile
          variants={listVariants}
          initial="closed"
          animate={isOpen ? "open" : "closed"}
          
        >
      {['inicio', 'servicios', 'portafolio', 'contacto'].map((section, i) => (
        <motion.li
          key={section}
          variants={itemVariants}
          whileTap={{ scale: 0.9 }}
        >
          <NavLink
            mobileNavLink
            to={section}
            smooth
            duration={500}
            onClick={() => {
            setTimeout(() => setIsOpen(false), 550);
            }}
          >
              {t(`header.${(section.charAt(0).toUpperCase() + section.slice(1))}`)}
          </NavLink>
      </motion.li>
  ))}

  <motion.li variants={itemVariants} whileTap={{ scale: 0.9 }}
  
  >
    <LangButton onClick={toggleLanguage}>
      {i18n.language === 'es' ? 'EN' : 'ES'}
    </LangButton>
  </motion.li>
        </MenuUlMobile>
      </motion.div>      


      
      <BurgerButton
        onClick={() => setIsOpen(!isOpen)}
        whileTap={{ scale: 0.8 }}
      >
        <motion.span
          style={{ width: 25, height: 3, background: '#fff' }}
          animate={isOpen ? { rotate: 45, y: 8 } : { rotate: 0, y: 0 }}
        />
        <motion.span
          style={{ width: 25, height: 3, background: '#fff' }}
          animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
        />
        <motion.span
          style={{ width: 25, height: 3, background: '#fff' }}
          animate={isOpen ? { rotate: -45, y: -8 } : { rotate: 0, y: 0 }}
        />
      </BurgerButton>
      <NavPc>
        <NavLink to="inicio" smooth duration={500}>{t('header.Inicio')}</NavLink>
        <NavLink to="servicios" smooth duration={500}>{t('header.Servicios')}</NavLink>
        <NavLink to="portafolio" smooth duration={500}>{t('header.Portafolio')}</NavLink>
        <NavLink to="contacto" smooth duration={500}>{t('header.Contacto')}</NavLink>
          <LangButton onClick={toggleLanguage}>
            {i18n.language === 'es' ? 'EN' : 'ES'}
          </LangButton>
      </NavPc>


     

        

    </HeaderWrapper>
  );
}


const HeaderWrapper = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 50;
  background-color: #0D0D0D;
  box-shadow: 0 2px 4px hsla(0, 0.00%, 0.00%, 0.30);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    color: #ffffff;
    min-width: 60px;
    text-align: center;
  }
`;

const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: bold;
  color: #FF4C4C;
  cursor: pointer;
`;

const NavPc = styled.nav`
  display: none;
  @media(min-width: 1024px) {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
`;
const navMobileStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  backgroundColor: '#0000',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
};

const BurgerButton = styled(motion.button)`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 1rem;
  z-index: 50;

  @media(min-width: 1024px) {
    display: none;
  }
`;

const MenuUlMobile = styled(motion.ul) `
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 90%;
    width: 90%;

    a {
      padding: 15px 45px ;
    }
`;

const NavLink = styled(ScrollLink)`
  text-align: center;
  @media (min-width: 1024px) {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  ${props => props.mobileNavLink && css`
        background-color: #000;
        color: #fff;
        padding: 20px;
        border: 2px solid red;
        width: 160px;
        border-radius: 15px;
    `}
`;

const LangButton = styled.button`
  margin-left: 1rem;
  padding: 0.25rem 0.75rem;
  height: 30px;
  width: 100px;
  font-size: 0.875rem;
  background-color: #E63946;
  color: white;
  border-radius: 10px;
  transition: background-color 0.3s, transform .3s;
  border: none;
  &:active {
    background-color: #FF4C4C;
    transform: scale(.8);
  }
  @media(max-width: 768px) {
    min-width: 160px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
